module.exports = __webpack_public_path__ + "static/002.thumb-a4de5a40471e34aa34ecb2621e48f520.jpg";